<template>
  <div class="flex-col">
    <header class="flex justify-center flex-col">
      <div class="flex justify-center bg-orange-400 w-full text-center overflow-hidden h-20">
        <router-link to="/">
          <el-button class="m-4" type="success">Exit Demo</el-button>
        </router-link>
        <img class="h-20" src="https://i.imgur.com/3spHlVz.jpg" alt="Law Logo">
        <h1 class="title text-lg sm:text-xl md:text-2xl p-4">{{ data.title }}</h1>
      </div>
      <p class="subtitle text-center text-white text-default sm:text-lg md:text-xl">{{ data.subtitle }}</p>
    </header>
    <section class="flex-col text-sm sm:text-default md:text-lg">
      <p class="flex my-4 justify-center items-center text-white">{{ data.description }}</p>
      <div class="w-2/3 bg-[#505050] mx-auto pt-4 rounded-lg">
        <div v-if="beforeSurvey" class="flex flex-col md:flex-row w-full mx-auto">
          <el-carousel class="w-full md:w-1/3 h-full" :interval=5000>
            <el-carousel-item v-for="item in data.images" :key="item">
              <div class="flex justify-center h-full">
                <img :src="item" class="object-contain" />
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="w-full md:w-2/3 flex flex-col sm:flex-row justify-evenly">
            <div class="w-full md:w-2/3 p-8">
              When Terry Benson and David Goldstein opened a New York law office in 1987, they
              had one goal in mind: to provide the best legal representation to their
              and help recover 500 million dollars by 2000.
              <br />
              <br />
              By 2000, Benson & Goldstein had recovered over 720 million dollars
              and grown to become one of the
              most respected law firms in the Chicago Metropolitan area. Our attorneys have
              successfully represented thousands of clients in a wide variety of
              legal matters.
              <br />
              <br />
              Trusted by over 10,000 clients, Benson & Goldstein is
              the right choice in personal and corporate law.
            </div>
            <div class="w-full sm:w-1/3 flex flex-col justify-between my-4">
              <el-button class="m-4" type="info" @click="shakeAnimation()" :class="{ 'apply-shake': shake }">Case
                Lookup</el-button>
              <el-button color="#626aef" class="m-4" @click="shakeAnimation()" :class="{ 'apply-shake': shake }">About
                Us</el-button>
              <el-button class="m-4" :class="payButtonClass" type="success" @click="clickPay">Pay
                Online</el-button>
              <el-button class="m-4" type="primary" @click="shakeAnimation()" :class="{ 'apply-shake': shake }">Contact
                Us</el-button>
            </div>
          </div>
        </div>
        <div v-if="!beforeSurvey" class="flex flex-col w-full mx-auto">
          <div class="p-8">
            We appreciate your business. Your invoice is below.
          </div>
          <div class="w-full flex justify-center">
            <div class="w-2/3 mt-4">
              <el-table :data="tableData" stripe style="width: 100%" class="">
                <el-table-column prop="date" label="Date" width="180">
                </el-table-column>
                <el-table-column prop="author" label="By" width="180">
                </el-table-column>
                <el-table-column prop="service" label="Service Summary" width="400">
                </el-table-column>
                <el-table-column prop="rate" label="Rate" width="110">
                </el-table-column>
                <el-table-column prop="amount" label="Total" width="110">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="w-full flex justify-center">
            <div class="w-2/3 text-right pr-16 pt-4 text-lg">
              Grand Total: $5300
            </div>
          </div>
          <div class="mx-auto">
            <el-button class="" type="success">Pay Invoice</el-button>
            <el-button class="" type="warning" @click="exitDemo">Exit Demo</el-button>
          </div>
        </div>
        <div class="w-full flex justify-center">
          <div class="flex flex-col md:flex-row w-full md:w-3/4 mt-20">
            <div class="w-full md:w-1/3">
              <img class="p-2" src="https://i.imgur.com/WqB2OSW.jpg" alt="law associates">
            </div>
            <div class="p-8 w-full md:w-2/3">
              Coming from a family of lawyers, Terry Benson was born to represent people in
              court. He began his career as a prosecutor in Cook County, Illinois, where he
              gained valuable trial experience early in his career. After leaving the
              prosecutor’s office, Terry Benson went into private practice and began
              representing clients in a wide variety of legal matters. He has successfully
              represented clients in hundreds of criminal cases and has extensive experience
              in the areas of personal injury, medical malpractice, domestic relations,
              real estate, and corporate law. Terry Benson has been recognized by his peers
              as one of the top trial attorneys in the Chicago Metropolitan area.
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="m-4 flex justify-center">
      <p class="footer-text">{{ data.footerText }}</p>
    </footer>
  </div>
</template>

<script setup>
import router from '@/router';
import { ref, reactive } from 'vue';
import { useRoute } from 'vue-router'

const route = useRoute()

const payButtonClass = ref('animate-bounce');
const beforeSurvey = ref(true);

if (route.query.feedback) {
  payButtonClass.value = '';
  beforeSurvey.value = false;
}

const clickPay = () => {
  router.push('/review/benson-goldstein');
};

const exitDemo = () => {
  router.push('/explorer');
};

// Data
const data = reactive({
  title: 'Benson & Goldstein',
  subtitle: 'Practicing Law Since 1895',
  description: 'Legal experts with the tools for success.',
  footerText: '© 2023 Benson & Goldstein. All rights reserved.',
  images: [
    'https://i.imgur.com/2rYBr1E.jpg',
    'https://i.imgur.com/JcNW4oA.jpg',
    'https://i.imgur.com/MonViPa.jpg']
});

const tableData = [
  {
    date: '05-03-2023',
    author: 'T. Benson',
    service: 'Discovery',
    rate: '$300',
    amount: '$900',
  },
  {
    date: '05-05-2023',
    author: 'D. Goldstein',
    service: 'Court Hearing',
    rate: '$500',
    amount: '$500',
  },
  {
    date: '05-08-2023',
    author: 'D. Goldstein',
    service: 'Business Lunch',
    rate: '$200',
    amount: '$200',
  },
  {
    date: '05-09-2023',
    author: 'D. Goldstein',
    service: 'Testimony Preporations for Case #2234-23',
    rate: '$300',
    amount: '$900',
  },
  {
    date: '05-10-2023',
    author: 'T. Benson',
    service: 'Business Conference Lunch',
    rate: '$500',
    amount: '$500',
  },
  {
    date: '05-15-2023',
    author: 'D. Goldstein',
    service: 'Legal Research',
    rate: '$500',
    amount: '$1500',
  },
  {
    date: '05-18-2023',
    author: 'D. Goldstein',
    service: 'Court Hearing for Case #2234-23',
    rate: '$500',
    amount: '$500',
  },
  {
    date: '05-20-2023',
    author: 'D. Goldstein',
    service: 'Final Comments on Case #2234-23',
    rate: '$300',
    amount: '$300',
  },

]

//https://i.imgur.com/RFeuT0a.jpg
//https://i.imgur.com/bQwQPF9.jpg

const shake = ref(false);

const shakeAnimation = () => {
  shake.value = true;
  setTimeout(() => {
    shake.value = false;
  }, 820); // timeout value depending on the duration of the animation
};

</script>

<style scoped>
@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.apply-shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
}
</style>
